<template>
  <div class="row">
    <div class="col-lg-12 col-xl-12 mb-5">
      <dashboard-box title="Napolyon (100 TL Nakit Para Transferi)">
        <template v-slot:toolbar>
          <b-input-group class="mt-3">
            <b-form-select
                size="sm"
                class="form-control form-control-solid"
                v-model="date_filter_selected"
                :options="date_filters">
            </b-form-select>
            <b-input-group-append>
              <b-button size="sm"><i class="far fa-file-excel"></i> {{ $t('general.import_excel') }}</b-button>
            </b-input-group-append>
          </b-input-group>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col sm="12" lg="3" xl="3" class="mb-5">
              <b-input-group size="sm">
                <b-form-input placeholder="Arama yapın"></b-form-input>
                <b-input-group-append>
                  <b-button variant="primary"><i class="fa fa-search"></i> Ara</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col sm="112" lg="9" xl="9">
              <b-button-group size="sm" class="fa-pull-right">
                <b-button><i class="far fa-check-circle"></i> Onayla</b-button>
                <b-button><i class="far fa-clock"></i> Beklemeye Al</b-button>
                <b-button><i class="far fa-calendar-times"></i> Reddet</b-button>
                <b-button><i class="far fa-times-circle"></i> İptal Et</b-button>
                <b-button><i class="fas fa-undo-alt"></i> Onay Tarihini Geri Al</b-button>
              </b-button-group>
            </b-col>
          </b-row>
          <data-table
              :items="table.items"
              :fields="report.fields"
              :paginate="report.paginate"
              page.sync="3"
              perPage.sync="10"
          ></data-table>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";
import DashboardBox from "@/assets/components/DashboardBox";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  name: "NapTransferRequests",
  components: { DataTable, DashboardBox },
  methods: {

  },
  data() {
    return {
      form : {

      },
      date_filter_selected : 'Son 1 Ay',
      date_filters : ['Son 1 Ay', 'Son 3 Ay', 'Son 6 Ay', 'Son 1 Yıl'],
      report : {
        paginate : {
          next_page_url: "#",
          path: "#",
          per_page: 15,
          prev_page_url: null,
          to: 15,
          total: 48,
          pageNumberProxy:1,
          current_page : 1,
          first_page_url: "http://127.0.0.1:8000/api/samples?page=1",
          from: 1,
          last_page: 20,
          last_page_url: "http://127.0.0.1:8000/api/samples?page=2",
          links: [
            {
              "url": null,
              "label": "&laquo; Öncekiler",
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=1",
              "label": 1,
              "active": true
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": 2,
              "active": false
            },
            {
              "url": "http://127.0.0.1:8000/api/samples?page=2",
              "label": "Sonrakiler &raquo;",
              "active": false
            }
          ],
        },
        fields: [
          {key: 'checkbox', label: '', sortable: true},
          {key: 'created_at', label: 'Tarih', sortable: true},
          {key: 'member_id', label: 'Member ID', sortable: true},
          {key: 'fullname', label: 'Adı Soyadı', sortable: true},
          {key: 'tckn', label: 'TCKN', sortable: true},
          {key: 'email', label: 'Email', sortable: true},
          {key: 'point', label: 'Puanı', sortable: true},
          {key: 'status', label: 'Durumu', sortable: true},
          {key: 'city', label: 'Şehir', sortable: true},
          {key: 'iban', label: 'IBAN', sortable: true},
          {key: 'last_action_date', label: 'Son İşlem', sortable: false},
          {key: 'sub_user', label: 'Alt Üye', sortable: false},
          {key: 'valid_sub_user', label: 'Geçerli Alt Üye', sortable: false},
          {key: 'payment_requests', label: 'Ödeme Talepleri', sortable: true},
          {key: 'registration_year', label: 'Kayıt Yılı', sortable: false},
        ],
      },
      table : {
        items : [
          {
            'created_at' : '08.01.2021',
            'member_id' : '3871304',
            'fullname' : 'Ali Taştan',
            'tckn' : '123456789',
            'email' : 'ali@mail.com',
            'point' : '14500',
            'status' : 'Aktif',
            'city' : 'İstanbul',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '13.12.2020',
            'sub_user' : '1',
            'valid_sub_user' : '1',
            'payment_requests' : '2',
            'registration_year' : '2015',
          },
          {
            'created_at' : '09.01.2021',
            'member_id' : '3875555',
            'fullname' : 'Ayşe Duran',
            'tckn' : '123456789',
            'email' : 'ayse@mail.com',
            'point' : '25400',
            'status' : 'Aktif',
            'city' : 'Samsun',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '12.12.2020',
            'sub_user' : '2',
            'valid_sub_user' : '2',
            'payment_requests' : '1',
            'registration_year' : '2010',
          },
          {
            'created_at' : '10.01.2021',
            'member_id' : '3875355',
            'fullname' : 'Fazıl Menekşe',
            'tckn' : '123456789',
            'email' : 'fazil@mail.com',
            'point' : '5400',
            'status' : 'Aktif',
            'city' : 'Elazığ',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '13.12.2020',
            'sub_user' : '1',
            'valid_sub_user' : '1',
            'payment_requests' : '4',
            'registration_year' : '2017',
          },
          {
            'created_at' : '11.01.2021',
            'member_id' : '3874455',
            'fullname' : 'Emre Ceviz',
            'tckn' : '123456789',
            'email' : 'emre@mail.com',
            'point' : '18200',
            'status' : 'Aktif',
            'city' : 'Muş',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '14.12.2020',
            'sub_user' : '1',
            'valid_sub_user' : '1',
            'payment_requests' : '1',
            'registration_year' : '2013',
          },
          {
            'created_at' : '12.01.2021',
            'member_id' : '3874845',
            'fullname' : 'Rukiye Baylan',
            'tckn' : '123456789',
            'email' : 'rukiye@mail.com',
            'point' : '54500',
            'status' : 'Aktif',
            'city' : 'Trabzon',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '15.12.2020',
            'sub_user' : '1',
            'valid_sub_user' : '1',
            'payment_requests' : '1',
            'registration_year' : '2017',
          },
          {
            'created_at' : '13.01.2021',
            'member_id' : '3874846',
            'fullname' : 'Furkan Çelik',
            'tckn' : '123456789',
            'email' : 'furkan@mail.com',
            'point' : '3500',
            'status' : 'Aktif',
            'city' : 'Sivas',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '16.12.2020',
            'sub_user' : '1',
            'valid_sub_user' : '1',
            'payment_requests' : '1',
            'registration_year' : '2019',
          },
          {
            'created_at' : '14.01.2021',
            'member_id' : '3874847',
            'fullname' : 'Emin Akyol',
            'tckn' : '123456789',
            'email' : 'emin@mail.com',
            'point' : '3500',
            'status' : 'Aktif',
            'city' : 'Çankırı',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '17.12.2020',
            'sub_user' : '1',
            'valid_sub_user' : '1',
            'payment_requests' : '1',
            'registration_year' : '2018',
          },
          {
            'created_at' : '15.01.2021',
            'member_id' : '3874848',
            'fullname' : 'Tuğba Deniz',
            'tckn' : '123456789',
            'email' : 'tugba@mail.com',
            'point' : '78050',
            'status' : 'Aktif',
            'city' : 'Edirne',
            'iban' : 'TR1788195314531313',
            'last_action_date' : '18.12.2020',
            'sub_user' : '1',
            'valid_sub_user' : '1',
            'payment_requests' : '1',
            'registration_year' : '2020',
          },
        ],
      },
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: this.$t('general.project_2'), route: "alert" },
      { title: 'Napolyon (100 TL Nakit Para Transferi)' }
    ]);
  }
}
</script>

<style scoped>

</style>
